import React, { useCallback } from "react";
import {
  ActionCreatorWithoutPayload,
  ActionCreatorWithPayload,
} from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { Persistor } from "redux-persist";
import { useQueryClient } from "react-query";

import { useJwtExpiry } from "../hooks/useJwtExpiry";
import useRefreshAuthMutation from "../hooks/useRefreshAuth";

interface JwtProviderProps {
  children: React.ReactNode;
  tokenSelector: (state: any) => { token: string };
  resetAuthAction: ActionCreatorWithoutPayload<string>;
  setTokenAction: ActionCreatorWithPayload<{ token: string }, string>;
  persistor?: Persistor;
}

const JwtProviderComponent: React.FC<JwtProviderProps> = ({
  children,
  tokenSelector,
  resetAuthAction,
  setTokenAction,
  persistor,
}) => {
  const queryClient = useQueryClient();
  const refreshAuthMutation = useRefreshAuthMutation(setTokenAction);
  const { token } = useSelector(tokenSelector);

  const handleTokenRefresh = useCallback(async () => {
    await refreshAuthMutation.mutateAsync({ token });
  }, [refreshAuthMutation, token]);

  useJwtExpiry(
    tokenSelector,
    resetAuthAction,
    handleTokenRefresh,
    persistor,
    queryClient
  );
  return <>{children}</>;
};

// Memoize to prevent unnecessary remounts during navigation
export const JwtProvider = React.memo(JwtProviderComponent);
